const MILLION = 1_000_000;

export function formatTokenCount(value: number): string {
  if (value < MILLION) {
    return value.toLocaleString('en-GB');
  }

  return `${(value / MILLION).toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}M`;
}